import { AbstractDimension } from '@orus.eu/dimensions'
import { type EsMrpwQuote, quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'
import type { Result } from '@orus.eu/result'

import type { EsMrpwQuoteFailure } from './common-types.ts'

export type EsMrpwQuoteResult = Result<EsMrpwQuote, EsMrpwQuoteFailure>

export class EsMrpwQuoteDimension<NAME extends string> extends AbstractDimension<NAME, EsMrpwQuoteResult> {
  override formatToString(value: EsMrpwQuoteResult): string {
    if (value.type === 'failure') {
      return `NULL - ${value.problem.type}`
    }
    return quoteV3ToSerializedQuoteData(value.output)
  }
}

export const esMrpwQuoteDimension = new EsMrpwQuoteDimension({
  name: 'esMrpwQuote',
  displayKeys: { name: 'dimension_name_es_mrpw_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
